import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { routes } from "@config/utilities/utils.constant";

export const BrainstormingMobileAppIdea = () => {
  return (
    <section className=" bg-[#f3ebfa] py-20 mb-32 space-y-8 px-2">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px]  text-center  font-bold text-dark font-butler capitalize"
      >
        Brainstorming a mobile app idea?{" "}
      </motion.h2>
 
      <div className="container flex flex-col justify-center items-center  space-y-8 ">
        <div className="space-y-4">
          <p  className="text-center text-xl  ">
            Get in touch with us to explore how we can assist with bringing your
            vision to life.
          </p>
        </div>
       <div className="z-10">
                <Link
                  to={routes.CONTACTUS}
                  aria-label="Internal link to Contact Us page"
                >
                  <button title="Book Discovery Call" className="  px-6 py-4 bg-[#FFC067] text-dark font-bold rounded shadow text-base  md:text-lg transition  hover-filled  ">
                    Book Discovery Call
                  </button>
                </Link>
              </div> 
      </div>
    </section>
  );
};
